import { getCallbackDisplayLabel, uniqueDisplayLabels } from '../../util/parentSettingSave';

/** Save-bar labels for AGENTIC_CHECKOUT value fields (single config, multiple UI sections). */
export const AGENTIC_CHECKOUT_TRANSACTION_LIMITS_LABEL = 'Transaction limits';
export const AGENTIC_CHECKOUT_TOOL_CALL_LIMITS_LABEL = 'Tool call limits';

export type AgenticCheckoutDirtyFields = {
  maxTransactionAmount?: boolean;
  maxLookupShopperCalls?: boolean;
  maxGeneratePaylinkCalls?: boolean;
  validateTotalCallbackUrl?: boolean;
  isValidateTotalCallbackEnabled?: boolean;
};

export function getAgenticCheckoutInheritableSaveBarLabels(
  dirtyFields: AgenticCheckoutDirtyFields,
): string[] {
  const labels: string[] = [];
  if (dirtyFields.maxTransactionAmount) {
    labels.push(AGENTIC_CHECKOUT_TRANSACTION_LIMITS_LABEL);
  }
  if (dirtyFields.maxLookupShopperCalls || dirtyFields.maxGeneratePaylinkCalls) {
    labels.push(AGENTIC_CHECKOUT_TOOL_CALL_LIMITS_LABEL);
  }
  if (dirtyFields.validateTotalCallbackUrl || dirtyFields.isValidateTotalCallbackEnabled) {
    labels.push(getCallbackDisplayLabel('AgenticCheckoutValidateTotal'));
  }
  return uniqueDisplayLabels(labels);
}
